/**
 * @generated SignedSource<<69f72c5ca6ef29354c59b94a486aab6f>>
 * @relayHash 05b845c8efe81277acaeb266d39890d6
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/534.0.0-2025-10-29T15:24:42.463Z/usePdpShippingInfoQueryQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type usePdpShippingInfoQueryQuery$variables = {
  afterDisplay?: boolean | null;
  fetchItem?: boolean | null;
  fetchRegionalInfo?: boolean | null;
  fetchUser?: boolean | null;
  isTrade?: boolean | null;
  itemId: string;
  itemQuantity?: number | null;
  shippingRegions?: ReadonlyArray<string | null> | null;
  userCountryCode?: string | null;
  userId: string;
  userZipCode?: string | null;
};
export type usePdpShippingInfoQueryQuery$data = {
  readonly viewer: {
    readonly geography: {
      readonly countries: ReadonlyArray<{
        readonly abbreviation: string | null;
        readonly name: string | null;
      } | null> | null;
    } | null;
    readonly itemRead?: ReadonlyArray<{
      readonly address?: {
        readonly country: string | null;
        readonly displayCountry: string | null;
      } | null;
      readonly isDutiesEstimateEligible?: boolean | null;
      readonly isItemRTQuoteEligibly?: boolean | null;
      readonly isNewAndMadeToOrder?: boolean | null;
      readonly serviceId?: string | null;
      readonly vertical?: VerticalType | null;
      readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDutiesMessage_item" | "PdpSharedLowerShippingInfo_item" | "PdpSharedReturns_item" | "PdpSharedShippingAndReturns_item" | "PdpSharedShippingInfoLink_item" | "PdpSharedShippingInfoWrapper_item" | "useShippingPrice_item" | "useShippingType_item" | "useShowReturns_item">;
    } | null> | null;
    readonly regionSelectorEnabled: boolean | null;
    readonly relevantShipping: {
      readonly mlFreightQuotesAbTestVariant: string | null;
      readonly quoteRequestStatus: string | null;
      readonly shipment: {
        readonly shippingAddress: {
          readonly displayCityStateCountry: string | null;
        } | null;
      } | null;
      readonly shipmentQuote: {
        readonly buyerServiceMethodDisplay: string | null;
        readonly handlingTimeDisplay: string | null;
        readonly handlingTimeDisplayUnformatted: {
          readonly max: number | null;
          readonly min: number | null;
          readonly unit: string | null;
        } | null;
        readonly serviceMethod: {
          readonly serviceMethodType: string | null;
          readonly serviceType: string | null;
        } | null;
        readonly showQuoteAsPending: boolean | null;
        readonly subTotalAmount: {
          readonly convertedAmountList: ReadonlyArray<{
            readonly amount: number | null;
            readonly currency: Currency | null;
          } | null> | null;
        } | null;
        readonly type: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingInfoLink_shipmentQuote" | "TrackQuoteShown_shipmentQuote">;
      } | null;
    } | null;
    readonly user?: {
      readonly addressBook: {
        readonly addressList: ReadonlyArray<{
          readonly country: string | null;
          readonly displayCountry: string | null;
          readonly zipCode: string | null;
        } | null> | null;
        readonly personalAddress: {
          readonly country: string | null;
          readonly displayCountry: string | null;
          readonly zipCode: string | null;
        } | null;
        readonly proAddress: {
          readonly country: string | null;
          readonly displayCountry: string | null;
          readonly zipCode: string | null;
        } | null;
      } | null;
      readonly serviceId: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"PdpSharedPromoCode_user" | "PdpSharedReturns_user" | "PdpSharedShippingAddress_user" | "PdpSharedShippingInfoLink_user" | "useShippingAndReturns_user" | "useUserGeoInfo_user">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpSharedLowerShippingInfo_viewer" | "PdpSharedPromoCode_viewer" | "PdpSharedShippingAddress_viewer" | "PdpSharedShippingInfoLink_viewer" | "useShippingPrice_viewer" | "useShippingType_viewer">;
  };
};
export type usePdpShippingInfoQueryQuery = {
  response: usePdpShippingInfoQueryQuery$data;
  variables: usePdpShippingInfoQueryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "afterDisplay"
},
v1 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchItem"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchRegionalInfo"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchUser"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isTrade"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemQuantity"
},
v7 = {
  "defaultValue": ([]/*: any*/),
  "kind": "LocalArgument",
  "name": "shippingRegions"
},
v8 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v10 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userZipCode"
},
v11 = {
  "kind": "Variable",
  "name": "fetchRegionalInfo",
  "variableName": "fetchRegionalInfo"
},
v12 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v13 = {
  "kind": "Variable",
  "name": "userZipCode",
  "variableName": "userZipCode"
},
v14 = [
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/)
],
v15 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
},
v16 = {
  "kind": "Variable",
  "name": "itemQuantity",
  "variableName": "itemQuantity"
},
v17 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v18 = {
  "alias": "regionSelectorEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "pdpRegionSelector"
    }
  ],
  "kind": "ScalarField",
  "name": "featureFlag",
  "storageKey": "featureFlag(feature:\"pdpRegionSelector\")"
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "Geography",
  "kind": "LinkedField",
  "name": "geography",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GeographyObject",
      "kind": "LinkedField",
      "name": "countries",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "abbreviation",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v20 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
},
v21 = {
  "kind": "Variable",
  "name": "countryCode",
  "variableName": "userCountryCode"
},
v22 = {
  "kind": "Variable",
  "name": "quantity",
  "variableName": "itemQuantity"
},
v23 = {
  "kind": "Variable",
  "name": "zipCode",
  "variableName": "userZipCode"
},
v24 = [
  (v20/*: any*/),
  (v21/*: any*/),
  (v15/*: any*/),
  (v22/*: any*/),
  (v23/*: any*/)
],
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quoteRequestStatus",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mlFreightQuotesAbTestVariant",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "displayShort",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "handlingTimeDisplay",
  "storageKey": "handlingTimeDisplay(displayShort:true)"
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "TimePeriod",
  "kind": "LinkedField",
  "name": "handlingTimeDisplayUnformatted",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "min",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "max",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unit",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v30 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ConvertedAmountList",
    "kind": "LinkedField",
    "name": "convertedAmountList",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "subTotalAmount",
  "plural": false,
  "selections": (v30/*: any*/),
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "buyerServiceMethodDisplay",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showQuoteAsPending",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceType",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceMethodType",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayCityStateCountry",
  "storageKey": null
},
v37 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "itemIds.0",
        "variableName": "itemId"
      }
    ],
    "kind": "ListValue",
    "name": "itemIds"
  }
],
v38 = {
  "kind": "Literal",
  "name": "fetchShippingCostInfo",
  "value": true
},
v39 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v40 = {
  "kind": "Variable",
  "name": "shippingRegions",
  "variableName": "shippingRegions"
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v42 = [
  (v20/*: any*/),
  (v21/*: any*/),
  (v23/*: any*/)
],
v43 = {
  "alias": null,
  "args": (v42/*: any*/),
  "kind": "ScalarField",
  "name": "isItemRTQuoteEligibly",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": (v42/*: any*/),
  "kind": "ScalarField",
  "name": "isDutiesEstimateEligible",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vertical",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayCountry",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isNewAndMadeToOrder",
  "storageKey": null
},
v49 = [
  (v17/*: any*/)
],
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zipCode",
  "storageKey": null
},
v51 = [
  (v46/*: any*/),
  (v47/*: any*/),
  (v50/*: any*/)
],
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "buyerTotalAmount",
  "plural": false,
  "selections": (v30/*: any*/),
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "truncate",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "daysRelativeToExpiration",
  "storageKey": "daysRelativeToExpiration(truncate:false)"
},
v56 = [
  (v47/*: any*/),
  (v50/*: any*/),
  (v41/*: any*/),
  (v53/*: any*/),
  (v46/*: any*/)
],
v57 = [
  (v20/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "usePdpShippingInfoQueryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpSharedShippingInfoLink_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpSharedPromoCode_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpSharedShippingAddress_viewer"
          },
          {
            "args": (v14/*: any*/),
            "kind": "FragmentSpread",
            "name": "PdpSharedLowerShippingInfo_viewer"
          },
          {
            "args": (v14/*: any*/),
            "kind": "FragmentSpread",
            "name": "useShippingPrice_viewer"
          },
          {
            "args": [
              (v11/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v12/*: any*/),
              (v17/*: any*/),
              (v13/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "useShippingType_viewer"
          },
          (v18/*: any*/),
          (v19/*: any*/),
          {
            "alias": null,
            "args": (v24/*: any*/),
            "concreteType": "RelevantShippingInfo",
            "kind": "LinkedField",
            "name": "relevantShipping",
            "plural": false,
            "selections": [
              (v25/*: any*/),
              (v26/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ShipmentQuote",
                "kind": "LinkedField",
                "name": "shipmentQuote",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PdpSharedShippingInfoLink_shipmentQuote"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TrackQuoteShown_shipmentQuote"
                  },
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ShipmentServiceMethod",
                    "kind": "LinkedField",
                    "name": "serviceMethod",
                    "plural": false,
                    "selections": [
                      (v34/*: any*/),
                      (v35/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Shipment",
                "kind": "LinkedField",
                "name": "shipment",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "shippingAddress",
                    "plural": false,
                    "selections": [
                      (v36/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "condition": "fetchItem",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v37/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "itemRead",
                "plural": true,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": [
                          (v20/*: any*/),
                          (v38/*: any*/),
                          (v39/*: any*/),
                          (v16/*: any*/),
                          (v40/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/)
                        ],
                        "kind": "FragmentSpread",
                        "name": "PdpSharedLowerShippingInfo_item"
                      },
                      {
                        "args": [
                          (v20/*: any*/),
                          (v38/*: any*/),
                          (v16/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/)
                        ],
                        "kind": "FragmentSpread",
                        "name": "useShippingPrice_item"
                      },
                      {
                        "args": [
                          (v16/*: any*/),
                          (v12/*: any*/),
                          (v17/*: any*/),
                          (v13/*: any*/)
                        ],
                        "kind": "FragmentSpread",
                        "name": "useShippingType_item"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PdpSharedShippingInfoLink_item"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PdpSharedShippingInfoWrapper_item"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PdpSharedDutiesMessage_item"
                      },
                      (v41/*: any*/),
                      (v43/*: any*/),
                      (v44/*: any*/),
                      (v45/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "address",
                        "plural": false,
                        "selections": [
                          (v46/*: any*/),
                          (v47/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v48/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PdpSharedShippingAndReturns_item"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PdpSharedReturns_item"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "useShowReturns_item"
                      }
                    ],
                    "type": "Item",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v49/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PdpSharedPromoCode_user"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PdpSharedShippingInfoLink_user"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PdpSharedShippingAddress_user"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "useUserGeoInfo_user"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PdpSharedReturns_user"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "useShippingAndReturns_user"
                  },
                  (v41/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AddressBook",
                    "kind": "LinkedField",
                    "name": "addressBook",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "proAddress",
                        "plural": false,
                        "selections": (v51/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "personalAddress",
                        "plural": false,
                        "selections": (v51/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "addressList",
                        "plural": true,
                        "selections": (v51/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v9/*: any*/),
      (v2/*: any*/),
      (v10/*: any*/),
      (v8/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "usePdpShippingInfoQueryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              (v15/*: any*/),
              (v17/*: any*/)
            ],
            "concreteType": "Promotion",
            "kind": "LinkedField",
            "name": "activePromotion",
            "plural": false,
            "selections": [
              (v52/*: any*/),
              (v53/*: any*/)
            ],
            "storageKey": null
          },
          (v19/*: any*/),
          {
            "alias": null,
            "args": (v24/*: any*/),
            "concreteType": "RelevantShippingInfo",
            "kind": "LinkedField",
            "name": "relevantShipping",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ShipmentQuote",
                "kind": "LinkedField",
                "name": "shipmentQuote",
                "plural": false,
                "selections": [
                  (v31/*: any*/),
                  (v53/*: any*/),
                  (v33/*: any*/),
                  (v27/*: any*/),
                  (v54/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v32/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ShipmentServiceMethod",
                    "kind": "LinkedField",
                    "name": "serviceMethod",
                    "plural": false,
                    "selections": [
                      (v34/*: any*/),
                      (v35/*: any*/),
                      (v53/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v25/*: any*/),
              (v26/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Shipment",
                "kind": "LinkedField",
                "name": "shipment",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "shippingAddress",
                    "plural": false,
                    "selections": [
                      (v36/*: any*/),
                      (v53/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v53/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v18/*: any*/),
          (v53/*: any*/),
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v20/*: any*/),
                  (v15/*: any*/)
                ],
                "concreteType": "Conversation",
                "kind": "LinkedField",
                "name": "buyerItemConversation",
                "plural": false,
                "selections": [
                  (v41/*: any*/),
                  (v53/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v49/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "condition": "isTrade",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "daysToExpiration",
                            "value": 7
                          },
                          {
                            "kind": "Literal",
                            "name": "promoCodes",
                            "value": [
                              "TRADEWELCOME",
                              "TRADE1STWELCOME"
                            ]
                          }
                        ],
                        "concreteType": "Promotion",
                        "kind": "LinkedField",
                        "name": "expiringPromotion",
                        "plural": false,
                        "selections": [
                          (v55/*: any*/),
                          (v52/*: any*/),
                          (v53/*: any*/)
                        ],
                        "storageKey": "expiringPromotion(daysToExpiration:7,promoCodes:[\"TRADEWELCOME\",\"TRADE1STWELCOME\"])"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "kind": "LinkedField",
                        "name": "tradeFirmRewards",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v49/*: any*/),
                            "concreteType": "currentPromoSegmentType",
                            "kind": "LinkedField",
                            "name": "currentPromoSegment",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Promotion",
                                "kind": "LinkedField",
                                "name": "promotion",
                                "plural": false,
                                "selections": [
                                  (v52/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "buyerExpirationDate",
                                    "storageKey": null
                                  },
                                  (v53/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "expiringPromoSegmentType",
                            "kind": "LinkedField",
                            "name": "expiringPromoSegment",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "expiringSegmentCode",
                                "storageKey": null
                              },
                              (v55/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmType",
                        "kind": "LinkedField",
                        "name": "tradeFirm",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeFirmRewards",
                            "kind": "LinkedField",
                            "name": "rewards",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": (v49/*: any*/),
                                "concreteType": "currentPromoSegmentType",
                                "kind": "LinkedField",
                                "name": "currentPromoSegment",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "segmentCode",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v53/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  (v41/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AddressBook",
                    "kind": "LinkedField",
                    "name": "addressBook",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "addressList",
                        "plural": true,
                        "selections": (v56/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "proAddress",
                        "plural": false,
                        "selections": (v56/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "personalAddress",
                        "plural": false,
                        "selections": (v56/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v53/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "fetchRegionalInfo",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "regionsInfo",
                "args": [
                  (v21/*: any*/),
                  (v23/*: any*/)
                ],
                "concreteType": "RegionalInfo",
                "kind": "LinkedField",
                "name": "regionalInfo",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RegionsByZipCode",
                    "kind": "LinkedField",
                    "name": "regionsByZipCode",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v53/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "fetchItem",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v37/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "itemRead",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v41/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 0
                          },
                          (v40/*: any*/)
                        ],
                        "concreteType": "moreLikeThisConnection",
                        "kind": "LinkedField",
                        "name": "moreLikeThis",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalResults",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          (v20/*: any*/),
                          (v39/*: any*/),
                          (v12/*: any*/)
                        ],
                        "concreteType": "ItemDisplayPriceType",
                        "kind": "LinkedField",
                        "name": "displayPrice",
                        "plural": true,
                        "selections": (v30/*: any*/),
                        "storageKey": null
                      },
                      (v45/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ShipmentQuote",
                        "kind": "LinkedField",
                        "name": "shipmentQuotes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isComplimentary",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isCalculated",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "totalAmount",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ConvertedAmounts",
                                "kind": "LinkedField",
                                "name": "convertedAmounts",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "USD",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ShipmentServiceMethod",
                            "kind": "LinkedField",
                            "name": "serviceMethod",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Region",
                                "kind": "LinkedField",
                                "name": "region",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "regionName",
                                    "storageKey": null
                                  },
                                  (v53/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v53/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v53/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "useLiveEndpoint",
                            "value": true
                          },
                          (v23/*: any*/)
                        ],
                        "concreteType": "RelevantShippingInfo",
                        "kind": "LinkedField",
                        "name": "relevantShippingInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ShipmentQuote",
                            "kind": "LinkedField",
                            "name": "shipmentQuote",
                            "plural": false,
                            "selections": [
                              (v54/*: any*/),
                              (v53/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "priceType",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "buyerId",
                            "value": ""
                          },
                          {
                            "kind": "Literal",
                            "name": "isTrade",
                            "value": false
                          }
                        ],
                        "concreteType": "ItemDisplayPriceType",
                        "kind": "LinkedField",
                        "name": "displayPrice",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "textType",
                            "storageKey": null
                          }
                        ],
                        "storageKey": "displayPrice(buyerId:\"\",isTrade:false)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasShipmentQuotes",
                        "storageKey": null
                      },
                      {
                        "alias": "itemIsOnHold",
                        "args": (v57/*: any*/),
                        "kind": "ScalarField",
                        "name": "isOnHold",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPrivateListing",
                        "storageKey": null
                      },
                      (v44/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "defaultSkuId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isAuctionEnabled",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v57/*: any*/),
                        "concreteType": "Transaction",
                        "kind": "LinkedField",
                        "name": "lastActiveTransaction",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isAuctionOrderType",
                            "storageKey": null
                          },
                          (v53/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v43/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "address",
                        "plural": false,
                        "selections": [
                          (v46/*: any*/),
                          (v47/*: any*/),
                          (v53/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v48/*: any*/),
                      {
                        "alias": null,
                        "args": (v49/*: any*/),
                        "concreteType": "ReturnPolicy",
                        "kind": "LinkedField",
                        "name": "returnPolicy",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "includeEuReturns",
                                "value": true
                              },
                              (v12/*: any*/)
                            ],
                            "kind": "ScalarField",
                            "name": "returnDays",
                            "storageKey": null
                          },
                          (v53/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "Item",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v53/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/534.0.0-2025-10-29T15:24:42.463Z/usePdpShippingInfoQueryQuery",
    "metadata": {},
    "name": "usePdpShippingInfoQueryQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "06d6b19d19265e67f0dcf206e1ec54e2";

export default node;
